export function getOr(path, defaultResult, obj) {
  if (!Array.isArray(path)) {
    path = path.split('.');
  } else {
    path = path.slice();
  }

  try {
    while (path.length) {
      const first = path.shift();
      obj = obj[first];
    }

    if (typeof obj === 'undefined') {
      return defaultResult;
    }

    return obj;
  } catch (e) {
    return defaultResult;
  }
}

export function get(path, obj) {
  return getOr(path, undefined, obj);
}
